var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',{staticClass:"upOthers"},[_c('TitleAppBar',{attrs:{"title":'Le Festival',"menu":_vm.menu}}),_c('router-view')],1),(this.$route.name === 'festivalInfo')?_c('div',{staticClass:"greyPart"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }